/**
 * Action for Fetch maintenance banner details
 */
export enum getBannerData {
  FETCH_BANNER_DATA_REQUEST = 'FETCH_BANNER_DATA_REQUEST'
}
